<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店内分类</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card
      shadow="hover"
      style="min-height: 150px"
      v-loading="!pageData && loading"
    >
      <div v-if="pageData" style="padding: 20px">
        <div style="margin-bottom: 5px">
          <el-button type="primary" @click="createClick">
            新建一级分类
          </el-button>
          <el-button type="default" @click="exportClick"> 导出类目 </el-button>
          <el-button type="default" @click="importClick"> 批量处理 </el-button>
          <el-button @click="refreshList" :loading="pageData && loading">
            刷新
          </el-button>
        </div>
        <el-table
          lazy
          ref="table"
          :data="pageData"
          :load="loadChildren"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @expand-change="handleExpandChange"
          row-key="guid"
        >
          <el-table-column prop="classifyName" label="分类名称" min-width="220">
            <template slot-scope="scope">
              {{ scope.row.classifyName }}
            </template>
          </el-table-column>
          <el-table-column prop="guid" label="分类编号" width="220">
          </el-table-column>
          <el-table-column prop="optSort" label="排序编号" width="120">
          </el-table-column>
          <el-table-column prop="goodsCount" label="商品数量" width="120">
          </el-table-column>
          <el-table-column prop="action" label="操作" width="220" fixed="right">
            <template slot-scope="scope">
              <template v-if="scope.row.parentGuid == '0'">
                <el-link type="primary" @click="createChildrenClick(scope.row)">
                  新建二级分类
                </el-link>
                <el-divider direction="vertical"></el-divider>
              </template>
              <el-link type="primary" @click="editClick(scope.row)">
                编辑
              </el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link type="danger" @click="deleteClick(scope.row)">
                删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px">
          <span style="color: #919191">
            *
            店内分类为商品线上销售属性，可自行按需设置，设置后会在销售页面按照对应分类进行商品展示。
          </span>
        </div>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="refreshList" size="small">
          重新加载
        </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<style lang="less" scoped>
</style>

<script>
import formPage from "./form.vue";
import importPage from './__index_import.vue';
import exportPage from './__index_export.vue';

export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    pageParams() {
      return Object.assign({},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign({},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      pageData: null,
      deleteLoading: false,
      currentParentGuid: null,
      tableTreeRefreshTool: {}
    };
  },
  methods: {
    importClick() {
      this.$drawer.openDrawer({
        title: '批量新增/更新商品类目信息',
        refresh: this.refreshList,
        component: importPage,
        params: {},
      }, true);
    },
    exportClick() {
      this.$drawer.openDrawer({
        title: '导出商品类目',
        refresh: this.refreshList,
        component: exportPage,
        params: {},
      }, true);
    },
    editClick(row) {
      this.$drawer.openDrawer({
        title: "编辑分类",
        component: formPage,
        refresh: () => {
          this.refreshByRow(row.parentGuid);
        },
        params: {
          parentGuid: row.parentGuid,
          guid: row.guid
        },
      }, true);
    },
    deleteClick(row) {
      this.$confirm("确定删除?", "提示", {
        type: "warning",
      }).then(() => {
        this.requestApi("biz.goods.classify.info.delete", {
          guid: row.guid,
        }, { showError: true }).then(() => {
          this.$drawer.refreshDrawer();
          this.success("删除成功");
          this.refreshByRow(row.parentGuid);
        });
      });
    },
    createChildrenClick(row) {
      this.$drawer.openDrawer({
        title: "新建二级分类",
        component: formPage,
        refresh: () => {
          this.refreshByRow(row.guid);
        },
        params: {
          parentGuid: row.guid
        },
      }, true);
    },
    createClick() {
      this.$drawer.openDrawer({
        title: "新建一级分类",
        component: formPage,
        refresh: this.refreshList,
        params: {},
      }, true);
    },
    loadChildren(tree, treeNode, resolve) {
      this.currentParentGuid = tree.guid
      this.tableTreeRefreshTool[tree.guid] = {}
      this.tableTreeRefreshTool[tree.guid].resolve = resolve;
      this.tableTreeRefreshTool[tree.guid].expandCount = 0;
      this.requestApi("biz.goods.classify.info.list", {
        parentGuid: tree.guid
      }).then((resp) => {
        resolve((resp.data.list || []).map(item => {
          return Object.assign({
            hasChildren: item.childrenCount > 0,
          }, item)
        }));
      }).catch((err) => {
        resolve([]);
      });
    },
    handleExpandChange(tree, expanded) {
      const curr = this.tableTreeRefreshTool[tree.guid]
      curr.expandCount++
      curr.prevStatus = expanded;
      this.refreshChildrenList(tree.guid);
    },
    refreshChildrenList(parentGuid) {
      const curr = this.tableTreeRefreshTool[parentGuid]
      if (curr && curr.prevStatus) {
        this.requestApi("biz.goods.classify.info.list", { parentGuid }).then((resp) => {
          return resp.data.list || [];
        }).catch((err) => {
          return [];
        }).then((resp) => {
          this.$set(this.$refs.table.store.states.lazyTreeNodeMap,
            parentGuid, resp.map(item => {
              return Object.assign({
                hasChildren: item.childrenCount > 0,
              }, item)
            }))
        });
      }
    },
    refreshList() {
      this.errorMsg = null;
      this.loading = true;
      return this.requestApi("biz.goods.classify.info.list").then((resp) => {
        this.loading = false;
        this.pageData = (resp.data.list || []).map(item => {
          return Object.assign({ hasChildren: item.childrenCount > 0 }, item)
        });
      }).catch((err) => {
        this.loading = false;
        this.errorMsg = (err && (err.msg || err.message))
          || "连接服务器失败，请检查网络";
      });
    },
    refreshByRow(parentGuid) {
      this.refreshTool();
      this.refreshChildrenList(parentGuid);
      this.refreshList();
    },
    refreshTool() {
      (this.pageData || []).forEach(item => {
        if (!item.hasChildren) {
          this.tableTreeRefreshTool[item.guid] = undefined;
          delete this.tableTreeRefreshTool[item.guid];
        }
      });
    },
  },
  mounted() {
    this.refreshList();
  },
};
</script>
